import React, { Component } from "react";
import { getDuration } from "~/tools/mll/helpers";
import { format } from "date-fns";
import "./style.scss";

class Timer extends Component {
  state = {
    liveNow:
      Date.now() - this.props.scheduleEndDate < 0 &&
      Date.now() - this.props.scheduleStartDate > 0,
    startsIn: this.props.scheduleStartDate - Date.now()
  };

  componentDidMount = () => {
    if (this.props.scheduleStartDate - Date.now() < 24 * 3600000) {
      this.interval = setInterval(() => this.checkLive(), 1000);
    } else {
      this.interval = setInterval(() => this.checkLive(), 60000);
    }
  };

  componentWillUnmount = () => {
    clearInterval(this.interval);
  };

  checkLive = () => {
    if (this.state.liveNow) {
      this.props.checkLive && this.props.checkLive()
      this.props.closeTimer && this.props.closeTimer();
      clearInterval(this.interval);
    }
    if (this.props.scheduleStartDate - Date.now() <= 60000 && !this.cleared) {
      clearInterval(this.interval);
      this.cleared = true;
      this.interval = setInterval(() => this.checkLive(), 1000);
    }
    this.setState({
      liveNow:
        Date.now() - this.props.scheduleEndDate < 0 &&
        Date.now() - this.props.scheduleStartDate > 0,
      startsIn: this.props.scheduleStartDate - Date.now()
    });
  };

  render() {
    const remainingTime = Math.floor(this.state.startsIn / 60000);
    const hours = Math.round(remainingTime / 60);
    const minutes = (remainingTime / 60) * 60;
    const days = Math.round(hours / 24);
    let duration = getDuration(this.state.startsIn);
    let time;
    if (!this.props.displayDetailedTime) {
      if (hours >= 1 && hours <= 24 && minutes >= 60) {
        //time = ` ${hours}h`;
        time = format(this.props.scheduleStartDate, 'hh:mm A')
      } else if (hours > 24 && days >= 1) {
        //time = ` ${days}d`;
        time = format(this.props.scheduleStartDate, 'hh:mm A')
      } else {
        let duration = getDuration(this.state.startsIn);
        time = `${duration.getMinutes()}:${duration.getSeconds()}`;
      }
    } else {
      if (hours >= 1 && hours <= 24 && minutes >= 60) {
        time = ` ${duration.getHours()}h ${duration.getMinutes()}m ${duration.getSeconds()}s`;
      } else if (hours > 24 && days >= 1) {
        time = `Live this ${format(
          this.props.scheduleStartDate,
          "ddd  h:mm a"
        )}`;
      } else {
        time = ` ${duration.getMinutes()}m ${duration.getSeconds()}s`;
      }
    }
    const { shortForm, displayDetailedTime } = this.props;
    return (
      <div className="stop-watch">
        {!this.state.liveNow &&
          (displayDetailedTime && (hours > 24 && days >= 1) ? (
            <div className={`"timer-icon" ${displayDetailedTime ? 'starts-in' : ''}`}>{time}</div>
          ) : (
            <div className={`${shortForm ? '' : 'timer-icon'} ${displayDetailedTime ? 'starts-in' : ''}`}>
              {shortForm || (this.props.scheduleEndDate && (hours >= 1 && minutes >= 60) && !displayDetailedTime) ? "" : " Starts in "}
              <span className={shortForm ? "" : "time"}>
                {time}
              </span>
            </div>
          ))}
        {this.state.liveNow && (
          <div className="live-game">
            <div className="text">
              <p>LIVE NOW</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Timer;
